import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UnpaidOrdersModal from '../../Report/form/zreport/modal/unpaidOrders'
import { clearUnpaidModal } from '../../../redux/action/unpaidOrdersModal'
import { checkUnpaidOnLoginThunk } from '../../../redux/thunk/unpaidOrders'
import { postLogoutThunk } from '../../../redux/thunk/registration/auth'
import { closeCashRegisterThunk } from '../../../redux/thunk/zreport'
import { selectIsAuthorized } from '../../../redux/selector/system'
import { selectIsSubscriptionModalActive } from '../../../redux/selector/company'

const GlobalUnpaidOrdersModal = React.memo(() => {
	const dispatch = useDispatch()
	const visible = useSelector(store => store.unpaidOrdersModal.visible)
	const dateFrom = useSelector(store => store.unpaidOrdersModal.dateFrom)
	const dateTo = useSelector(store => store.unpaidOrdersModal.dateTo)
	const blocking = useSelector(store => store.unpaidOrdersModal.blocking)
	const isAuthorized = useSelector(selectIsAuthorized)
	const isSubscriptionModalActive = useSelector(selectIsSubscriptionModalActive)

	useEffect(() => {
		if (isAuthorized) {
			dispatch(checkUnpaidOnLoginThunk())
		}
	}, [isAuthorized, dispatch])

	const handleDismiss = useCallback(() => {
		dispatch(clearUnpaidModal())
	}, [dispatch])

	const handleLogout = useCallback(() => {
		dispatch(clearUnpaidModal())
		dispatch(postLogoutThunk())
	}, [dispatch])

	const handleResolveAllClose = useCallback(() => {
		dispatch(closeCashRegisterThunk())
		dispatch(clearUnpaidModal())
	}, [dispatch])

	const dateRange = useMemo(() => (dateFrom && dateTo) ? { from: dateFrom, to: dateTo } : undefined, [dateFrom, dateTo])

	return (
		<UnpaidOrdersModal isOpen={visible && !isSubscriptionModalActive}
											 navigateNext={blocking ? handleResolveAllClose : handleDismiss}
											 onClose={blocking ? handleLogout : handleDismiss}
											 blocking={blocking}
											 infoMessageKey={blocking
												 ? 'Reports.ZReports.modal.unpaidOrdersModal.infoMessageBlocked'
												 : 'Reports.ZReports.modal.unpaidOrdersModal.infoMessageLoginUnclosed'}
											 dateRange={dateRange} />
	)
})

GlobalUnpaidOrdersModal.displayName = 'GlobalUnpaidOrdersModal'
export default GlobalUnpaidOrdersModal
